import { Component } from '@angular/core';
import { NavController, NavParams, /*AlertController,*/ } from 'ionic-angular';
import { IonicPage } from 'ionic-angular';

import { MenuController } from 'ionic-angular/components/app/menu-controller';
import { CoreProvider } from './../../providers/core-service/core-service';

/**
 * Generated class for the LoginPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
    selector: 'page-login',
    templateUrl: 'login.html',
})
export class LoginPage {

    statusLogin: string;

    showLogin = false;

    online = true;
    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public menuCtrl: MenuController,
        private coreService: CoreProvider
    ) {

        /* endpoint.login().subscribe(result => {
 
             //console.log(result);
           
         }, err =>{
 
             //console.log(err);
         });*/
    }

    ionViewWillLeave() {
        // enable the root left menu when leaving this page
        this.showLogin = false;
        this.statusLogin = "";
        this.menuCtrl.enable(true);
    }

    ionViewWillEnter() {
        this.showLogin = true;
        this.statusLogin = "";
        this.menuCtrl.enable(false);

        this.coreService.checkAuth().subscribe(auth => {
            if (!auth) {
                //this.LoginWithGoogle();
                this.showLogin = true;
                this.statusLogin = "You are not logged in.";
            }
        });
        //console.log(this.coreService.getToken());
    }

    abort() {
        this.showLogin = true;
        this.statusLogin = "";
    }

    /*
      Metodo di login tramite pulsante della schermata iniziale
    */
    LoginWithGoogle() {

        this.showLogin = false;
        this.statusLogin = "";

        this.coreService.login().then(result => {
            //console.log(result);

        }).catch(e => {
            /*******
             *  catturo l'eventuale errore, gestisco alcuni casi
             *  come utente non esiste, password errata etc..
            ********/
            //console.log("error ->" + e + " code ->" + e.code);

            switch (e.code) {
                case 'auth/user-not-found': //user inesistente
                    this.statusLogin = "MSG_LOGIN_FAILED";
                    break;

                case 'auth/wrong-password': //password errata
                    this.statusLogin = "MSG_PASSWORD_wRONG";
                    break;

                default: //default error
                    this.statusLogin = e;
            }//fine switch
            /********
             *  Visualizzo l'errore in una toast
             */
            //this.coreService.showToast(this.statusLogin, 'top');

            this.showLogin = true;
            this.statusLogin = "You are not logged in.";

        });//fine catch

    } //fine LoginWithEmail



}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts